import { render } from "./CustomCoverUploader.vue?vue&type=template&id=3bf22e80"
import script from "./CustomCoverUploader.vue?vue&type=script&lang=js"
export * from "./CustomCoverUploader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__